export enum HttpMethod {
  Get = 'GET',
  Post = 'POST',
  Put = 'PUT',
  Delete = 'DELETE',
  Patch = 'PATCH',
  Options = 'OPTIONS',
  Head = 'HEAD',
}

export enum HttpStatusCode {
  ServiceUnavailable = 503,
  NotImplemented = 501,
  InternalServerError = 500,
  UpgradeRequired = 426,
  TooEarly = 425,
  FailedDependency = 424,
  Locked = 423,
  UnsupportedMediaType = 415,
  ContentTooLarge = 413,
  LengthRequired = 411,
  Gone = 410,
  Conflict = 409,
  RequestTimeout = 408,
  NotFound = 404,
  Forbidden = 403,
  Unauthorized = 401,
  BadRequest = 400,
  TemporaryRedirect = 307,
  NotModified = 304,
  Found = 302,
  SeeOther = 303,
  MovedPermanently = 301,
  MultipleChoices = 300,
  NoContent = 204,
  Accepted = 202,
  Created = 201,
  Ok = 200,
}
